import React from 'react';
import { Link } from '@tanstack/react-router';

const HackathonCTA: React.FC = () => {
  return (
    <div className="w-full max-w-7xl mx-auto px-4 py-12">
      <div className="relative">
        {/* Glow effect */}
        <div className="absolute -inset-1 bg-gradient-to-r from-cyan-500 via-purple-500 to-yellow-500 rounded-2xl blur opacity-50 group-hover:opacity-70 transition duration-1000 group-hover:duration-200 animate-gradient-x"></div>
        
        <div className="relative bg-purple-500 rounded-2xl shadow-lg overflow-hidden border border-purple-500">
          <div className="p-8 md:p-12">
            <div className="max-w-2xl mx-auto text-center space-y-8">
              <span className="scale-pulse">🎉</span>
              <h2 className="text-3xl md:text-4xl font-bold text-white">
                Join the Hackathon
              </h2>
              <p className="text-lg text-slate-200">
                Build something real with Python. One file, one week, no boilerplate.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <Link
                  to="/hackathon/register"
                  className="inline-block px-8 py-3 bg-white text-slate-900 border-2 border-cyan-500 hover:bg-cyan-50 transition-all duration-300 ease-in-out hover:shadow-lg hover:-translate-y-1 font-medium w-fit"
                >
                  Register now
                </Link>
                <Link
                  to="/hackathon/submit"
                  className="inline-block px-8 py-3 bg-white text-slate-900 border-2 border-green-500 hover:bg-green-50 transition-all duration-300 ease-in-out hover:shadow-lg hover:-translate-y-1 font-medium w-fit"
                >
                  Submit Project
                </Link>
                <a
                  href="https://join.slack.com/t/structuredlabs-users/shared_invite/zt-33zwhyv3l-6Xu4bHL6b6~bI3z9fvlUig"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block px-8 py-3 bg-white text-slate-900 border-2 border-yellow-500 hover:bg-yellow-50 transition-all duration-300 ease-in-out hover:shadow-lg hover:-translate-y-1 font-medium w-fit"
                >
                  Join Slack Community
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HackathonCTA; 